<template>
  <div
    class="btn-scroll-to-top"
    :class="{'show': y > 250}"
  >
    <!-- We have wrapper because ripple effect give position relative to this absolute positioned btn -->
    <!-- Hence due to that our btn get lost -->
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      class="btn-icon"
      @click="scrollToTop"
    >
      <feather-icon
        icon="ArrowUpIcon"
        size="16"
      />
    </b-button>
  </div>
</template>

<script>
import { useWindowScroll } from '@vueuse/core'
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'ScrollToTop',
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  setup() {
    const { y } = useWindowScroll()

    const scrollToTop = () => {
      const rootEle = document.documentElement
      rootEle.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }

    return { y, scrollToTop }
  },

}
</script>

<style lang="scss" scoped>
// Bootstrap functions/variables/mixins (no CSS output) — gives media-breakpoint-*.
@import '~@core/scss/base/bootstrap-extended/include';

.btn-scroll-to-top {
  position: fixed;
    bottom: 2%;
    right: 100px;
    z-index: 99;

    opacity: 0;
    // transform: translateY(100px);
    transition: all .5s ease;

    &.show {
      opacity: 1;
      // transform: translateY(0)
    }

    // Mobile: anchor to the bottom-right edge (was centre-ish at right:100px,
    // which on a narrow viewport floats over the products). Uses Bootstrap's
    // breakpoint mixin instead of a hard-coded media query (xs → ≤575.98px).
    @include media-breakpoint-down(xs) {
      right: 1rem;
      bottom: 1.25rem;
    }
}

// Hide the scroll-to-top button while a filter drawer/bottom-sheet is open
// (the body gets this class) so it doesn't float over the drawer footer.
body.v2-wishlist-drawer-open .btn-scroll-to-top,
// KP-4545: the branded line sheet has its own order bar where this would sit.
body.ls-branded-open .btn-scroll-to-top {
  display: none !important;
}
</style>
